import { call, put, takeEvery } from "redux-saga/effects";
import { demoLimitsSlice } from "./demoLimitsReducer";
import { sendNotificationMessageAction } from "../Notifications/notificationsReducer";
import {
    NOTIFICATION_MESSAGE_DEMO_LIMITS_EVENTS,
    NOTIFICATIONS_MESSAGE_TYPES
} from "../Notifications/notificationsConstants";
import { failurePut } from "../../app/failurePut";

function* getFreeOrdersLeftSaga() {
    try {
        yield put(
            sendNotificationMessageAction({
                type: NOTIFICATIONS_MESSAGE_TYPES.DEMO_LIMITS,
                params: {
                    event: NOTIFICATION_MESSAGE_DEMO_LIMITS_EVENTS.GET_ORDERS_LEFT,
                },
            }),
        );
    } catch (e) {
        yield call(failurePut, e, demoLimitsSlice.actions.getFreeOrdersLeftFailure);
    }
}

function* handleOrderCommittedSaga({ payload }: ReturnType<typeof demoLimitsSlice.actions.handleOrderCommittedAction>) {
    try {
        yield put(
            sendNotificationMessageAction({
                type: NOTIFICATIONS_MESSAGE_TYPES.DEMO_LIMITS,
                params: {
                    event: NOTIFICATION_MESSAGE_DEMO_LIMITS_EVENTS.ORDER_COMMITED,
                    payload: { accountCode: payload.accountCode },
                },
            }),
        );
    } catch (e) {
        yield call(failurePut, e, demoLimitsSlice.actions.getFreeOrdersLeftFailure);
    }
}

export function* demoLimitsSagas() {
    yield takeEvery(demoLimitsSlice.actions.getFreeOrdersLeftAction, getFreeOrdersLeftSaga);
    yield takeEvery(demoLimitsSlice.actions.handleOrderCommittedAction, handleOrderCommittedSaga);
}